import { render } from "./wapper.vue?vue&type=template&id=4f6777b2&scoped=true&ts=true"
import script from "./wapper.vue?vue&type=script&lang=ts"
export * from "./wapper.vue?vue&type=script&lang=ts"

import "./wapper.vue?vue&type=style&index=0&id=4f6777b2&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6777b2"]])

export default __exports__